import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { EmailService } from "../email/services";
import useUserStore from "../../store/user";
import { Page } from "../../components/page-base";
import { toast } from "react-toastify";

export const GoogleCallbackEmailPage: React.FC = () => {
  const { user } = useUserStore();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleEmailCallback = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get("code");
      const error = params.get("error");

      // Se o usuário negou a autorização
      if (error) {
        toast.error("Autorização cancelada ou negada pelo usuário.");
        navigate("/email");
        return;
      }

      if (!code) {
        toast.error("Código de autorização do Google não encontrado.");
        navigate("/email");
        return;
      }

      // Recupera o token do sessionStorage (mais seguro que URL)
      const storedToken = sessionStorage.getItem("oauth_token");
      const authToken = user?.token || storedToken;

      if (!authToken) {
        toast.error("Sessão expirada. Faça login novamente.");
        navigate("/login");
        return;
      }

      // Limpa o token do sessionStorage após uso
      sessionStorage.removeItem("oauth_token");

      // Chama o endpoint de callback para conectar o e-mail
      const result = await EmailService.googleCallback(code, authToken);

      // Verifica se foi bem-sucedido baseado no campo success
      if (result?.success) {
        toast.success(result.message || "E-mail conectado com sucesso!");
        // Redireciona com parâmetro para forçar refresh
        navigate("/email?refresh=true");
      } else {
        toast.error(result?.message || "Não foi possível conectar o e-mail.");
        // Redireciona de volta para a página de e-mails
        navigate("/email");
      }
    };

    handleEmailCallback();
  }, [location.search, navigate, user]);

  return (
    <Page.Root>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Page.Loader />
      </div>
    </Page.Root>
  );
};
